import {getDepartments} from '../../services/departments';
import {getLocations} from '../../services/locations';
import {getProjects} from '../../services/projects';
import {addErrorNotification} from '../../utils/notifications';


const state = {
    departments: [],
    locations: [],
    projects: []
}

const getters = {}

const actions = {
    async getFilters({state, commit}) {
        try {
            if (state.departments && state.departments.length > 0 && state.locations && state.locations.length > 0 && state.projects && state.projects.length > 0) {
                return
            }

            let [{rows: departments}, {rows: locations}, {rows: projects}] = await Promise.all([
                getDepartments(),
                getLocations(),
                getProjects()
            ])
            commit('setDepartments', departments.rows)
            // adding name property for MultiSelect component
            locations = locations.map(location => ({
                ...location,
                name: location.city
            }))
            commit('setLocations', locations)

            projects = projects.rows.map(project => ({
                ...project,
                name: project.title
            }))
            commit('setProjects', projects)
        } catch (e) {
            addErrorNotification('Unable to load jobs filters')
        }
    },

}

const mutations = {
    setDepartments(state, departments) {
        state.departments = departments
    },
    setLocations(state, locations) {
        state.locations = locations
    },
    setProjects(state, projects) {
        state.projects = projects
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/jobs.js